import { defineAction } from '~/prix'
import { z } from 'zod'
import collectionIncentiveDeleteAction from './collectionIncentiveDelete.action.json' with { type: 'json' }
import { collectionIncentiveObject } from '../collectionIncentiveObject'

const collectionIncentiveDeleteDefinition = defineAction({
  ...collectionIncentiveDeleteAction,

  input: z.object({ id: collectionIncentiveObject.shape.id }),
  output: z.object({}),
})

export default collectionIncentiveDeleteDefinition
